import Image from 'next/image';

import { Box, Card, Text } from '@zillow/constellation-10';

import { CELEBRATE_ILLUSTRATION_URL } from '../../../../../../constants/DigitalLibraryConstants';

const CelebrationCard = () => (
  <Card
    data-testid="CelebrationCard"
    css={{
      display: 'flex',
      alignItems: 'center',
      flexDirection: { base: 'column', md: 'row' },
      gap: { base: '300', md: '400' },
    }}
    elevated={false}
  >
    <Box
      data-testid="CelebrationImageContainer"
      css={{
        display: { base: 'none', md: 'block' },
        flexShrink: 0,
      }}
    >
      <Image src={CELEBRATE_ILLUSTRATION_URL} alt="Celebration" width={120} height={120} />
    </Box>

    <Box css={{ display: 'flex', flexDirection: 'column' }}>
      <Text textStyle="body-bold">Great job adding your property details!</Text>
      <Text>
        Now you can review and post individual units. Edit each unit to add photos, pricing, and availability, then
        publish when you&apos;re ready.
      </Text>
    </Box>
  </Card>
);

export default CelebrationCard;
